import React, { useEffect, useState } from 'react'
import { useLocation } from 'react-router-dom'

import { useGlobal } from '@jimmyboys/liita-ui/dist/components/GlobalContext'
import useQueryParams from '@jimmyboys/liita-ui/dist/hooks/useQueryParams'
import HStack from '@jimmyboys/liita-ui/dist/components/HStack'
import VStack from '@jimmyboys/liita-ui/dist/components/VStack'
import Dropdown from '@jimmyboys/liita-ui/dist/components/Dropdown'
import TextInput from '@jimmyboys/liita-ui/dist/components/TextInput'
import ActionButton from '@jimmyboys/liita-ui/dist/components/ActionButton'

import styles from '../ProtocolsController.module.sass'

const ProtocolsFilters = () => {
	const { i18n } = useGlobal()
	const location = useLocation()
	const [queryParams, , setQueryParams] = useQueryParams(location)
	const [processId, setProcessId] = useState('')

	const sortOptions = [
		{
			value: 'asc',
			text: i18n`Process ID, asc.`,
		},
		{
			value: 'desc',
			text: i18n`Process ID, desc.`,
		},
	]

	const protocolTypes = [
		{
			value: '',
			text: i18n`Any`,
		},
		{
			value: 'AppointmentClinicalApproval',
			text: i18n`AppointmentClinicalApproval`,
		},
		{
			value: 'MedicalActsClinicalApproval',
			text: i18n`MedicalActsClinicalApproval`,
		},
	]

	useEffect(() => {
		setProcessId(queryParams.processId || '')
	}, [queryParams.processId])

	const selectedType = queryParams?.protocolType
		? protocolTypes?.find(
				({ value }) =>
					queryParams.protocolType.toLocaleLowerCase() ===
					value.toLocaleLowerCase()
		  )
		: protocolTypes[0]

	const selectedSort = queryParams.sort
		? sortOptions.find(
				({ value }) =>
					queryParams.sort.toLocaleLowerCase() ===
					value.toLocaleLowerCase()
		  )
		: sortOptions[1]

	const handleSubmit = (e) => {
		e.preventDefault()
		setQueryParams({
			page: undefined,
			segment: undefined,
			processId,
		})
	}

	return (
		<HStack align='center' justify='space-between' gap='xsmall'>
			<HStack
				align='center'
				justify='flex-start'
				wrap='nowrap'
				gap='xsmall'
			>
				<VStack>
					<small>
						<strong>{i18n`Protocols`}</strong>
					</small>
					<small className='ellipsis'>{i18n`Order by`}:</small>
				</VStack>
				<div>
					<Dropdown
						className={styles['options-entry']}
						name='sort'
						value={selectedSort.value}
						options={sortOptions}
						onChange={(e) => {
							setQueryParams({
								page: undefined,
								segment: undefined,
								sort: e.target.value,
							})
						}}
					/>
				</div>

				<small className='ellipsis'>{i18n`Search by`}:</small>
				<form onSubmit={handleSubmit}>
					<HStack gap='xsmall' wrap='nowrap'>
						<TextInput
							type='text'
							value={processId}
							name='processId'
							placeholder={i18n`Process ID`}
							onChange={(e) => {
								setProcessId(e.target.value)
							}}
						/>
						<ActionButton type='submit' secondary>
							<small>
								<strong>{i18n`Search`}</strong>
							</small>
						</ActionButton>
					</HStack>
				</form>
			</HStack>
			<HStack
				className={styles['options-entry']}
				align='center'
				justify='flex-end'
				wrap='nowrap'
				gap='xsmall'
			>
				<Dropdown
					name='type'
					placeholder={i18n`Type`}
					searchable
					value={selectedType?.value}
					options={protocolTypes || []}
					onChange={(e) => {
						setQueryParams({
							page: undefined,
							segment: undefined,
							protocolType: e.target.value,
						})
					}}
				/>
			</HStack>
		</HStack>
	)
}

export default ProtocolsFilters
